import getReportingOption from '../store/store';
import { discardReportingOption } from '../actions/internalActions';
import { mutator } from 'satcheljs';

mutator(discardReportingOption, () => {
    const reportingOption = getReportingOption();
    reportingOption.reportJunkSelected = null;
    reportingOption.checkForReportJunkDialog = null;
});
